<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<approved-declined-selectbox/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<approved-declined-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<approved-declined-selectbox v-model="value3" :validate-error="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import ApprovedDeclinedSelectbox from "@/components/interactive-fields/ApprovedDeclinedSelectbox";

	export default {
		components: {
			ApprovedDeclinedSelectbox
		},
		data() {
			return {
				value1: null,
				value2: 'pending',
				value3: 'pending',
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 'approved'
				this.value3 = 'approved'
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

